import * as React from 'react';
import { flow, forEach, get, head } from 'lodash';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import { ICustomer, IOffer, IPremium, IProduct, IQuotes, ITraveller } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import { ICompleteData, IQuoteActions } from '../../../../services/quote/models';
import { formValueSelector, getFormValues, InjectedFormProps, reduxForm } from 'redux-form';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import { InfoAnnie } from '../../components/InfoAnnie';
import { format } from 'date-fns';
import Heap from '../../../../helpers/Heap';
import { bindActionCreators } from 'redux';
import { AdmiralHomeInsuranceBanner } from '../../../../components/AdmiralHomeInsuranceBanner';
import DataLayer from '../../../../helpers/DataLayer';

interface ICompleteProps extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  startDate: string;
  tripType: string;
  travellers: ITraveller[];

  renderDefinition(name: string): any;

  auth: IAuthState;
  data: ICompleteData;
  offers: IOffer;
  customer: ICustomer;
  quotes: IQuotes;
  branding: IBrandingState;
  premium: IPremium;
  formValues: any;
  actions: {
    quote: IQuoteActions;
    push(path: string);
    auth: IAuthActions;
  };
}

class IComplete extends React.Component<ICompleteProps, any> {

  public state = {
    showBanner: false,
  };

  constructor(props) {
    super(props);
  }

  public componentDidMount(): void {
    const props = this.props;
    const { data, branding } = props;
    Heap.trackEvent('PurchaseSuccess', get(props, 'formValues'), 'quote')
    const isBannerEnabled = get(branding, 'channel.products[0].metadata.direct_customer_mta_options.offers.household_banner.enabled', false)
    const policyId = get(data, 'policy_id');
    const leadTravellerEmail = get(props, 'formValues.travellers.[0].email');
    const isAggregator = get(branding, 'channel.channelType') === 'AGG';
    const communicationPref = get(props, 'formValues.communications.post', false) === false ? 'online' : 'post';
    if (!isAggregator) {
      DataLayer.push({
        'PurchaseSuccess': 'true',
        'PolicyNumber': data.policy_number,
        'LeadTravellerEmail': leadTravellerEmail,
        'documentPreferences': communicationPref,
        'Referafriend': '20',
      })
    }

    if (policyId && isBannerEnabled) {
      this.setState({ showBanner: true });
    }
  }

  private renderTrackingItems = () => {
    const { branding, premium, data } = this.props;

    const items = [];

    if (branding.aggregatorTracking.type === 'cyti') {
      const params = branding.aggregatorTracking.cyti;
      const cytiUrl = branding.aggregatorTracking.cyti.url + '/track/confirm';

      items.push(
        <img
          key={0}
          // tslint:disable-next-line:max-line-length
          src={`${cytiUrl}?cref=${params.cref}&policyreference=${data.policy_number}&premium=${premium.gross}&t=${params.token}`}
          height="0"
          width="0"
        />,
      );
    }

    if (branding.aggregatorTracking.type === 'idol') {
      const params = branding.aggregatorTracking.idol;
      const url = 'https://quotes.theidol.com/v1/travel/pixels/provisionalSales/admiral';

      items.push(
        <img
          key={0}
          src={`${url}?ref=${params.reference}&fullprem=${premium.gross}`}
          height="0"
          width="0"
        />,
      );
    }

    return items;
  }

  public render() {
    const { data, premium, startDate, tripType, travellers, actions } = this.props;

    const isAnnual = tripType === 'annual';
    const leadTraveller: ITraveller = head(travellers);
    const coverStartDate = isAnnual ? startDate : format(new Date(), 'dd/MM/yyyy')

    return (
      <div className="steps-container">
        <Form>
          <div className="purchase-complete-container">
            <div className={'purchase-complete-title'}>Purchase Complete</div>
            <div className={'purchase-complete-title-big'}>Your policy has been set up</div>
          </div>

          <InfoAnnie
            title={`Thank you, ${leadTraveller.firstName}!`}
            color={'green'}
            text={`We\'ve received payment for £${(premium.gross).toFixed(2)} and will send a confirmation email within 24 hours`}/>

          <div style={{ marginTop: '20px' }}/>

          <div className={'show-complete-info-container'}>
            <div className={'show-complete-header'}>
              <div className={'box--half'}>
                <div style={{ display: 'flex' }}>
                  <div className={'adm-icon-circle'}><img
                    src={require(isAnnual ? '../../img/plane-annual.svg' : '../../img/Plane.svg')} alt="Admiral"/>
                  </div>
                  <div>
                    <div
                      className={'complete-info-title'}>{isAnnual ? 'Multi-Trip Insurance' : 'Single-Trip Insurance'}</div>
                    <div> Policy number {data.policy_number}</div>
                  </div>
                </div>
              </div>
              <div className={'box--half'}>
                <div style={{ display: 'flex' }}>
                  <div className={'adm-icon-circle'}><img height={'30px'} src={require('../../img/date-white.svg')}
                                                          alt="Admiral"/>
                  </div>
                  <div>
                    <div className={'complete-info-title'}>Cover start</div>
                    <div>{coverStartDate}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'show-complete-body'}>
              <div className={'adm-icon-circle'}><img src={require('../../img/person.svg')} alt="Admiral"/></div>
              <div>
                <div className={'complete-info-title'}>Register Now!</div>
                <div>Our online portal has recently been improved and has <u>new functionality</u>. It may be faster and
                  easier to:
                </div>
                <div className={'my-account-list'}>
                  <div className={'icon'}><img src={require('../../img/blue-tick.svg')} alt="Admiral"/></div>
                  <div>View and download your policy documents</div>
                </div>
                <div className={'my-account-list'}>
                  <div className={'icon'}><img src={require('../../img/blue-tick.svg')} alt="Admiral"/></div>
                  <div>Change your travel plans: dates and destinations</div>
                </div>
                <div className={'my-account-list'}>
                  <div className={'icon'}><img src={require('../../img/blue-tick.svg')} alt="Admiral"/></div>
                  <div>Add travellers</div>
                </div>
                <div className={'my-account-list'}>
                  <div className={'icon'}><img src={require('../../img/blue-tick.svg')} alt="Admiral"/></div>
                  <div>Update your medical history</div>
                </div>
                <div className={'my-account-list'}>
                  <div className={'icon'}><img src={require('../../img/blue-tick.svg')} alt="Admiral"/></div>
                  <div>Add extra cover, <u>and more!</u></div>
                </div>

                <div className={'mt-15'}>
                  Shortly you will be receiving an email that will give you instructions on how to use your Travel
                  Portal moving forward.
                </div>

              </div>
            </div>
            <div style={{ borderBottom: '1px solid #ced9e5' }}/>
            <div className={'show-complete-body'}>
              <div className={'adm-icon-circle'}><img src={require('../../img/person.svg')} alt="Admiral"/></div>
              <div>
                <div className={'complete-info-title'}>Accessibility and Support</div>
                <div>We want to make sure it’s as easy as possible for everyone to use our products and services. We
                  are continuously trying to improve our accessibility for people who have disabilities, long term
                  health conditions, or are struggling with challenging times. For more information visit our
                  <a href={'https://www.admiral.com/accessibility'} target={'_blank'}> accessibility and
                    support</a> page.
                </div>
              </div>
            </div>
          </div>

          {this.state.showBanner &&
            <AdmiralHomeInsuranceBanner
              policyId={data.policy_id}
              authActions={actions.auth}
              customerName={leadTraveller?.firstName}
            />
          }

          {this.renderTrackingItems()}
        </Form>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes } = state.quote;

      let premium: IPremium = null;

      const values = selector(
        state,
        'tripType',
        'schemeId',
        'quoteReference',
      );

      const formValues = getFormValues('quote')(state);

      const startDate = selector(state, 'startDate');
      const tripType = selector(state, 'tripType');
      const travellers = selector(state, 'travellers');

      if (state.quote.quotes) {
        forEach(state.quote.quotes, (tripTypes, level) => {
          forEach(tripTypes, (quotedPremium: IPremium) => {
            if (!quotedPremium) {
              return null;
            }

            if (quotedPremium.scheme.id === values.schemeId) {
              premium = quotedPremium;
            }
          });
        });
      }

      return {
        auth: state.auth,
        data: state.quote.complete,
        offers: state.auth.offers,
        quotes,
        branding: state.branding,
        premium,
        formValues,
        startDate,
        travellers,
        tripType
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
      }
    }),
  ),
])(IComplete);
